module.exports = {"513233100":"邛溪镇","513233101":"刷经寺镇","513233102":"瓦切镇","513233103":"安曲镇","513233104":"色地镇","513233201":"龙日乡","513233202":"江茸乡","513233203":"查尔玛乡","513233205":"阿木乡","513233206":"壤口乡","513233207":"麦洼乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513233.json
// module id = 2411
// module chunks = 0